import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import { editUser, updateUser } from '../../services/apiService';
import Loader from '../Loader/Loader';

const EditUser = () => {
  const { id } = useParams();
  const [user, setUser] = useState({ 
    name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
   });
   const [loading, setLoading] = useState(true);
   const navigate = useNavigate();

  // Fetch user data by ID when component loads
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await editUser(id);
        setUser(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching IG data:', error);
      }
    };
    fetchUserData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };
  const userSubmit = async (e) => {
    e.preventDefault();
    //const validationErrors = validateForm();
    // if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const response = await updateUser(user, id);
        setUser({
          name: "",
          last_name: "",
          email: "",
          phone: "",
          password: "",
        });
        setLoading(false);
        navigate("/user-master", {
          state: { UserFormData: response.data.message },
        });
      } catch (error) {
        console.error("Failed to store data:", error.message);
      }
    // } else {
    //   setErrors(validationErrors);
    // }
  };
  // const validateForm = () => {
  //   const errors = {};
  //   if (!user.name.trim()) {
  //     errors.name = "First Name is required";
  //   }
  //   if (!user.last_name.trim()) {
  //     errors.last_name = "Last Name is required";
  //   }
  //   if (!user.email.trim()) {
  //     errors.email = "Email is required";
  //   } else if (!isValidEmail(user.email)) {
  //     errors.email = "Invalid email format";
  //   }
  //   // if (!user.phone.trim()) {
  //   //   errors.phone = "Mobile is required";
  //   // } else if (!isValidPhoneNumber(user.phone)) {
  //   //   errors.phone = "Invalid mobile number";
  //   // }
  //   // if (!user.password.trim()) {
  //   //   errors.password = "Password is required";
  //   // } else if (user.password.length < 6) {
  //   //   errors.password = "Password must be at least 6 characters long";
  //   // }
  //   // return errors;
  // };
  // const isValidEmail = (email) => {
  //   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  // };
  // const isValidPhoneNumber = (phone) => {
  //   return /^\d{10}$/.test(phone);
  // };
  const handleCancel = () => {
    setUser({
      name: "",
      last_name: "",
      email: "",
      phone: "",
      password: "",
    });
  };

  return (
    <>
      <Header/>
      <div className="container">
        <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
          </ol>
        </nav>
      </div>
      <div className="container pb-4">
      {loading ? (
              <Loader /> // Show the loader while data is loading
            ) : (
            <div className="box-bdr-dash">
              <div className="row">
                <div className="col-md-12">
                  <div className="box mb-2">
                    <div className="box-top-title fhir-title">
                      <span className="pd-overview-count">Edit User </span>
                    </div>
                    <div className="ig-forms">
                        <form onSubmit={userSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                  First Name{" "}
                                  <span className="text-danger fs-6">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control`}
                                  id="name"
                                  name="name"
                                  value={user.name}
                                  onChange={handleInputChange}
                                  aria-describedby="text"
                                  placeholder="First Name"
                                />
                                {/* {errors.name && (
                                  <div className="invalid-feedback">
                                    {errors.name}
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label htmlFor="last_name" className="form-label">
                                  Last Name{" "}
                                  <span className="text-danger fs-6">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control`}
                                  id="last_name"
                                  name="last_name"
                                  value={user.last_name}
                                  onChange={handleInputChange}
                                  aria-describedby="text"
                                  placeholder="Last Name"
                                />
                                {/* {errors.last_name && (
                                  <div className="invalid-feedback">
                                    {errors.last_name}
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label htmlFor="email" className="form-label">
                                  Email <span className="text-danger fs-6">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control`}
                                  id="email"
                                  name="email"
                                  value={user.email}
                                  onChange={handleInputChange}
                                  aria-describedby="text"
                                  placeholder="Email"
                                />
                                {/* {errors.email && (
                                  <div className="invalid-feedback">
                                    {errors.email}
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label htmlFor="phone" className="form-label">
                                  Mobile
                                </label>
                                <input
                                  type="text"
                                  className={`form-control`}
                                  id="phone"
                                  name="phone"
                                  value={user.phone}
                                  onChange={handleInputChange}
                                  aria-describedby="text"
                                  placeholder="Mobile"
                                />
                                {/* {errors.phone && (
                                  <div className="invalid-feedback">
                                    {errors.phone}
                                  </div>
                                )} */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label htmlFor="password" className="form-label">
                                  Password
                                </label>
                                <input
                                  type="password"
                                  className={`form-control`}
                                  id="password"
                                  name="password"
                                  value={user.password}
                                  onChange={handleInputChange}
                                  aria-describedby="text"
                                  placeholder="Password"
                                />
                                {/* {errors.password && (
                                  <div className="invalid-feedback">
                                    {errors.password}
                                  </div>
                                )} */}
                              </div>
                            </div>
                          </div>
                          <div className="form-buttons">
                            <button
                              type="submit"
                              className="btn btn-primary submit-btn"
                            >
                              <i className="fa fa-check" /> Submit
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary cancel-btn"
                              onClick={handleCancel}
                            >
                              <i className="fa fa-close" /> Cancel
                            </button>
                          </div>
                        </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            )}
      </div>
    </>
  );
};

export default EditUser;
